var BlogCover = {
	image: null, zoom: 1, x: .5, y: .5, error: '', url: null,
	choose: function(input) {
		BlogCover.image = null; BlogCover.error = '';
		var panel = document.getElementById('blog-cover-crop'); panel.hidden = true;
		if (BlogCover.url) URL.revokeObjectURL(BlogCover.url);
		BlogCover.url = null;
		if (!input.files.length) return;
		var file = input.files[0];
		if (file.size > 5 * 1024 * 1024) { BlogCover.error = 'Обложка должна быть не больше 5 МБ'; document.getElementById('blog-message').textContent = BlogCover.error; return; }
		BlogCover.url = URL.createObjectURL(file);
		var source = BlogCover.url;
		var image = new Image();
		image.onload = function() {
			if (BlogCover.url !== source) return;
			if (image.naturalWidth * image.naturalHeight > 25000000) { BlogCover.error = 'Обложка должна быть не больше 25 мегапикселей'; document.getElementById('blog-message').textContent = BlogCover.error; return; }
			BlogCover.image = image; BlogCover.zoom = 1; BlogCover.x = .5; BlogCover.y = .5;
			document.getElementById('blog-cover-zoom').value = 1; panel.hidden = false; BlogCover.draw();
		};
		image.onerror = function() { if (BlogCover.url !== source) return; BlogCover.error = 'Не удалось прочитать обложку'; document.getElementById('blog-message').textContent = BlogCover.error; };
		image.src = BlogCover.url;
	},
	rect: function() {
		var img = BlogCover.image;
		var width = Math.min(img.naturalWidth, img.naturalHeight * 8 / 3) / BlogCover.zoom;
		var height = width * 3 / 8;
		return {x: (img.naturalWidth - width) * BlogCover.x, y: (img.naturalHeight - height) * BlogCover.y, w: width, h: height};
	},
	draw: function() {
		if (!BlogCover.image) return;
		var canvas = document.getElementById('blog-cover-canvas'), r = BlogCover.rect();
		var ctx = canvas.getContext('2d'); ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.drawImage(BlogCover.image, r.x, r.y, r.w, r.h, 0, 0, canvas.width, canvas.height);
	},
	zoomTo: function(value) { BlogCover.zoom = Number(value); BlogCover.draw(); },
	init: function() {
		var canvas = document.getElementById('blog-cover-canvas'); if (!canvas) return;
		var drag = null;
		canvas.addEventListener('pointerdown', function(event) { if (!BlogCover.image) return; drag = {x: event.clientX, y: event.clientY, px: BlogCover.x, py: BlogCover.y}; canvas.setPointerCapture(event.pointerId); });
		canvas.addEventListener('pointermove', function(event) {
			if (!drag || !BlogCover.image) return;
			var r = BlogCover.rect(), scale = r.w / canvas.getBoundingClientRect().width, img = BlogCover.image;
			if (img.naturalWidth > r.w) BlogCover.x = Math.max(0, Math.min(1, drag.px - (event.clientX - drag.x) * scale / (img.naturalWidth - r.w)));
			if (img.naturalHeight > r.h) BlogCover.y = Math.max(0, Math.min(1, drag.py - (event.clientY - drag.y) * scale / (img.naturalHeight - r.h)));
			BlogCover.draw();
		});
		canvas.addEventListener('pointerup', function() { drag = null; }); canvas.addEventListener('pointercancel', function() { drag = null; });
	},
	export: function() {
		var input = document.getElementById('blog-cover');
		if (!input || !input.files.length) return Promise.resolve(null);
		if (BlogCover.error) return Promise.reject(new Error(BlogCover.error));
		if (!BlogCover.image) return Promise.reject(new Error('Дождитесь открытия обложки'));
		var r = BlogCover.rect(), canvas = document.createElement('canvas');
		canvas.width = Math.max(8, Math.min(1280, Math.round(r.w))); canvas.height = Math.round(canvas.width * 3 / 8);
		canvas.getContext('2d').drawImage(BlogCover.image, r.x, r.y, r.w, r.h, 0, 0, canvas.width, canvas.height);
		return new Promise(function(resolve, reject) { canvas.toBlob(function(blob) { if (blob && (blob.type === 'image/webp' || blob.type === 'image/png')) resolve(blob); else reject(new Error('Не удалось подготовить обложку')); }, 'image/webp', .85); });
	}
};
window.BlogCover = BlogCover;
module.exports = BlogCover;
